import React, { Fragment, useRef, useState, useEffect } from "react";
import { bool, string } from "prop-types";
import { useDispatch, connect, useSelector } from "react-redux";
import { push, goBack } from "connected-react-router";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as settingsActions } from "reducers/settings";
import { selectors as enrollmentSelector } from "reducers/enrollment";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col } from "react-bootstrap";
import * as i18nUtils from "util/i18n";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import {
    defaultTextCheckboxTermsAndConditions,
    defaultTextMigrationEnrolledUserStepFinish1,
    defaultTextMigrationEnrolledUserStepFinish2,
    defaultTextMigrationEnrolledUserStepFinish3,
    getValidationSchemaTermsAndConditions,
    TERMS_AND_CONDITIONS_CATEGORY_PF,
} from "../../../util/onboarding";
import Checkbox from "../../_components/Checkbox";

const checkboxContainerStyle = {
    display: "flex",
    flexDirection: "row",
    verticalAlign: "middle",
};
const checkboxLabelStyle = {
    paddingLeft: "0%",
    paddingTop: "0%",
    textAlign: "justify",
    textJustify: "interWord",
};

const FORM_ID = "onboarding.vu";

const StepFinishEnrolledUser = ({
    isMobile,
    onboardingWithInvitation,
    onboardingWithEnrolledUser,
    exchangeToken,
    acceptTermsAndConditionsPF,
    idEnvironment,
}) => {
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(acceptTermsAndConditionsPF);
    const { documents } = useSelector((state) => state.settings);

    useEffect(() => {
        dispatch(settingsActions.loadDocumentsEnrollmentRequest(TERMS_AND_CONDITIONS_CATEGORY_PF));
    }, [])

    const onChangeCheckboxTermsAndConditions = () => {
        setAcceptTermsAndConditions(!acceptTermsAndConditions);
        dispatch(onboardingActions.acceptTermsAndConditionsPF(!acceptTermsAndConditions));
    };

    const handleOnclickTermsAndConditions = () => {
        dispatch(settingsActions.downloadDocumentRequestWithIdEnv(documents[0]?.fileNameKey, TERMS_AND_CONDITIONS_CATEGORY_PF, idEnvironment));
    };

    const handleAcceptTermsAndConditions = () => {
        dispatch(
            onboardingActions.acceptTermsAndConditionsFinishStepPF(TERMS_AND_CONDITIONS_CATEGORY_PF, exchangeToken),
        );
    };

    const initialValuesForm = {
        termsConditions: acceptTermsAndConditionsPF,
    };

    const goHome = () => {
        dispatch(onboardingActions.setOnboardingWithEnrolledUser(false));
        dispatch(push("/"));
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: () => Yup.lazy(() => getValidationSchemaTermsAndConditions()),
        onSubmit: (valuesForm) => {
            if (valuesForm?.termsConditions) {
                handleAcceptTermsAndConditions();
            }
            goHome();
        },
    };
    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText
                            text={i18nUtils.get(
                                "migration.enrolled.user.stepFinish.1",
                                defaultTextMigrationEnrolledUserStepFinish1,
                            )}
                        />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image
                        src={
                            onboardingWithInvitation
                                ? "figma/illustrations/onboarding9.svg"
                                : "figma/illustrations/onboarding3.svg"
                        }
                        className="svg-image logo"
                    />
                </div>
                <div className="box box-border-soft">
                    <CustomText
                        text={i18nUtils.get(
                            "migration.enrolled.user.stepFinish.2",
                            defaultTextMigrationEnrolledUserStepFinish2,
                        )}
                    />
                </div>
                <div className="box box-shadow info">
                    <CustomText
                        text={i18nUtils.get(
                            "migration.enrolled.user.stepFinish.3",
                            defaultTextMigrationEnrolledUserStepFinish3,
                        )}
                    />
                </div>
                <Formik {...formikProps} ref={formRef} initialValues={initialValuesForm}>
                    {() => (
                        <Form className="above-the-fold" ref={formRef}>
                            <div className="form-actions">
                                <div style={checkboxContainerStyle}>
                                    <Field
                                        component={Checkbox}
                                        idForm={FORM_ID}
                                        name="termsConditions"
                                        hideLabel
                                        onChange={() => onChangeCheckboxTermsAndConditions()}
                                    />
                                    <Button
                                        style={checkboxLabelStyle}
                                        className="btn-link"
                                        block={false}
                                        onClick={() => handleOnclickTermsAndConditions()}>
                                        <CustomText
                                            text={i18nUtils.get(
                                                "onboarding.vu.terms.and.conditions.label",
                                                defaultTextCheckboxTermsAndConditions,
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div className="form-actions" style={{ paddingTop: "0" }}>
                                    <Button
                                        bsStyle="primary"
                                        defaultLabelText="Finalizar"
                                        type="submit"
                                        block
                                        disabled={!acceptTermsAndConditions}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};

StepFinishEnrolledUser.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithInvitation: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
    exchangeToken: string.isRequired,
    acceptTermsAndConditionsPF: bool.isRequired,
};

const mapStateToProps = (state) => ({
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
    exchangeToken: enrollmentSelector.getExchangeToken(state),
    acceptTermsAndConditionsPF: onboardingSelectors.getAcceptTermConditionsPF(state),
    idEnvironment: enrollmentSelector.getIdEnvironment(state),
});

export default connect(mapStateToProps)(StepFinishEnrolledUser);
